<script setup>
import PasswordForgotForm from "@/forms/PasswordForgotForm.vue";

definePage({
    meta: {
        layout: 'guest'
    }
})
</script>

<template>
    <password-forgot-form />
</template>
